import React from 'react';
export const ConsequencesSection = () => {
  return <section className="w-full bg-[#faf7f2] py-16 px-4 md:px-8 lg:px-16" data-id="element-11">
      <div className="max-w-6xl mx-auto" data-id="element-12">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-800 mb-6 text-center" data-id="element-13">
          Co się stanie, jeśli nic nie zrobisz?
        </h2>
        <div className="flex flex-col md:flex-row gap-8 md:gap-4 mb-10" data-id="element-14">
          <div className="md:w-1/2 relative" data-id="element-15">
            <div className="absolute inset-0 bg-black bg-opacity-20 rounded-lg" data-id="element-16"></div>
            <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rAlw57qnVzBW7UPXshdOvbuEaG2SFM3iCIc5rN" alt="Samotna kobieta w ciemnym pokoju" className="w-full h-full object-cover rounded-lg" data-id="element-17" />
            <div className="absolute bottom-6 left-6 text-white" data-id="element-18">
              <h3 className="font-serif text-2xl font-bold mb-2" data-id="element-19">Bez zmian</h3>
              <p className="text-sm md:text-base" data-id="element-20">
                Dalsze życie w emocjonalnej pustce
              </p>
            </div>
          </div>
          <div className="md:w-1/2 relative" data-id="element-21">
            <div className="absolute inset-0 bg-black bg-opacity-10 rounded-lg" data-id="element-22"></div>
            <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rAt2zAaSoE7RAV1BktgQ0ujCaYx5XHUJGWfKTw" alt="Szczęśliwa para trzymająca się za ręce" className="w-full h-full object-cover rounded-lg" data-id="element-23" />
            <div className="absolute bottom-6 left-6 text-white" data-id="element-24">
              <h3 className="font-serif text-2xl font-bold mb-2" data-id="element-25">
                Po zmianach
              </h3>
              <p className="text-sm md:text-base" data-id="element-26">
                Odzyskana bliskość i namiętność
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 md:p-8 rounded-lg shadow-md" data-id="element-27">
          <h3 className="font-serif text-2xl font-bold text-gray-800 mb-4" data-id="element-28">
            Konsekwencje braku działania:
          </h3>
          <ul className="space-y-3 text-gray-700" data-id="element-29">
            <li className="flex items-start" data-id="element-30">
              <div className="text-red-500 mr-2" data-id="element-31">•</div>
              <p data-id="element-32">
                Pogłębiające się poczucie odrzucenia i samotności, mimo życia w
                związku
              </p>
            </li>
            <li className="flex items-start" data-id="element-33">
              <div className="text-red-500 mr-2" data-id="element-34">•</div>
              <p data-id="element-35">
                Rosnąca frustracja, która wpływa na wszystkie obszary życia -
                pracę, relacje z dziećmi, przyjaciółmi
              </p>
            </li>
            <li className="flex items-start" data-id="element-36">
              <div className="text-red-500 mr-2" data-id="element-37">•</div>
              <p data-id="element-38">Utrata poczucia własnej kobiecości i atrakcyjności</p>
            </li>
            <li className="flex items-start" data-id="element-39">
              <div className="text-red-500 mr-2" data-id="element-40">•</div>
              <p data-id="element-41">
                Ryzyko, że mąż zacznie szukać uwagi i podziwu poza małżeństwem
              </p>
            </li>
            <li className="flex items-start" data-id="element-42">
              <div className="text-red-500 mr-2" data-id="element-43">•</div>
              <p data-id="element-44">
                Życie w "cichej desperacji" - pozornie wszystko jest w porządku,
                ale Ty więdniesz w środku
              </p>
            </li>
            <li className="flex items-start" data-id="element-45">
              <div className="text-red-500 mr-2" data-id="element-46">•</div>
              <p data-id="element-47">
                Perspektywa kolejnych 10, 20, 30 lat życia bez namiętności i
                prawdziwej bliskości
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>;
};